import { Formik } from 'formik';
import { validationSchemaReviewTicket, initialValuesReviewTicket } from './reviewTicketValidation';
import Form from "./reviewTicketForm";
import { useAxios } from "../../../../context/AxiosHookContext";

const FormCreateTicket = ({ onClose, ticket, getValues }) => {


    const axios = useAxios();

    const handleSubmit = async (ticketReview) => {

        const obtenerTexto = (numero) => {

            const labels = {
                1: 'Deficiente',
                2: 'Regular',
                3: 'Aceptable',
                4: 'Bueno',
                5: 'Excelente',
            };

            return labels[numero];

        }

        try {

            const valuesTransform = {
                support_type: ticket.support_type._id,
                support_subtype: ticket.support_subtype._id,
                support_subtype_1: ticket.support_subtype_1._id,
                status: ticket.status,
                requester: ticket.requester._id,
                support_assigned: ticket.support_assigned._id,
                support_created_by : ticket.support_created_by._id,
                created_date : ticket.created_date,
                
            }

            if (ticket.comment) {
                valuesTransform.comment = ticket.comment
            }
            if (ticket.closed_comment) {
                valuesTransform.closed_comment = ticket.closed_comment
            }

            if(ticket.finished_date){
                valuesTransform.finished_date = ticket.finished_date
            }
 
            ticketReview.politely_support = obtenerTexto(ticketReview.politely_support)
            ticketReview.pleasure_support = obtenerTexto(ticketReview.pleasure_support)

            valuesTransform.review = ticketReview

            await axios.put(`/tickets/${ticket._id}`, valuesTransform);

        } catch (error) {
            console.log(error)
        } finally {
            getValues();
        }

    }

    return (
        <Formik
            validationSchema={validationSchemaReviewTicket}
            initialValues={initialValuesReviewTicket}
            onSubmit={handleSubmit}
        >
            <Form onClose={() => { getValues(); onClose() }} ticket={ticket} />
        </Formik>
    )
}

export default FormCreateTicket